import Image from '@components/elements/image/image';
import MapBox from '@components/elements/map-box/map-box';
import BranchLocationPlugin from '@components/elements/map-box/plugins/branch-location-plugin';
import InfoTable, { InfoTableSection } from '@components/info-table/info-table';
import { v2_Branch } from '@crocodille/common';
import { useTranslation } from 'react-i18next';
import OpeningHoursTable from 'src/opening-hours-table/opening-hours-table';

import styles from './branch-detail.module.scss';

export const BranchDetailBanner: React.FC<{
  readonly imageSrc: string | null;
}> = ({ imageSrc }) => {
  return (
    <div className={styles.banner}>
      <Image
        src={imageSrc}
        alt=""
        role="presentation"
        fill
        style={{ objectFit: 'cover' }}
      />
    </div>
  );
};

export interface BranchDetailProps {
  readonly branch: v2_Branch;
}

const BranchDetail: React.FC<BranchDetailProps> = ({ branch }) => {
  const { t } = useTranslation('restaurants');

  return (
    <InfoTable>
      <InfoTableSection title={t('detail.address')}>
        <p>{branch.address}</p>
      </InfoTableSection>
      <InfoTableSection>
        <div className={styles.map}>
          <MapBox mapCenter={branch.location} fill mapZoom={14}>
            <BranchLocationPlugin
              branchLocations={[
                { location: branch.location, code: branch.code },
              ]}
            />
          </MapBox>
        </div>
      </InfoTableSection>

      <InfoTableSection title={t('detail.contact')}>
        <p>
          {branch.phoneNumber ? (
            <>
              <a href={`tel:${branch.phoneNumber}`}>{branch.phoneNumber}</a>
              <br />
            </>
          ) : null}
          {branch.email ? (
            <>
              <a href={`mailto:${branch.email}`}>{branch.email}</a>
              <br />
            </>
          ) : null}
        </p>
      </InfoTableSection>

      <InfoTableSection title={t('detail.opening_hours')}>
        <OpeningHoursTable openingHours={branch.openingHours} />
      </InfoTableSection>
    </InfoTable>
  );
};

export default BranchDetail;
